<div class="container-fluid">
    <div class="row mt-3">
        <div class="col">
            <div class="card">
                <div class="card-body">

                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <app-data-table pageSize="25" [columns]="columns" [loadPage]="loadPage" [(filters)]="filters"
                        [filtersComponent]="dataFilters">
                        <app-data-filters #dataFilters>
                            <app-data-filter-group>
                                <app-data-filter-input label="Company ID" [(model)]="filters.id"
                                    placeholder="Company ID">
                                </app-data-filter-input>
                                <app-data-filter-input label="Company Name" [(model)]="filters.name"
                                    placeholder="Company Name">
                                </app-data-filter-input>
                                <app-data-filter-datepicker label="Creation Date" [(model)]="filters.creationDate">
                                </app-data-filter-datepicker>
                                <app-data-filter-select label="Status" [(model)]="filters.status"
                                    [options]="statusFilterArray"></app-data-filter-select>
                            </app-data-filter-group>
                        </app-data-filters>
                    </app-data-table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #selectColumn let-id="id">
    <input type="checkbox" [value]="id" />
</ng-template>

<ng-template #nameColumn let-name="name">
    <strong>{{name}}</strong>
</ng-template>

<ng-template #firstEmailColumn let-firstEmail="firstEmail">
    <a href="mailto:{{firstEmail}}"><i class="fa fa-envelope"></i> {{firstEmail}}</a>
</ng-template>

<ng-template #firstPhoneColumn let-firstPhone="firstPhone">
    {{firstPhone}}
</ng-template>

<ng-template #addressColumn let-address="address">
    {{address}}
</ng-template>

<ng-template #villageColumn let-village="village">
    <strong>{{(village ? village.name : '')}}</strong>
</ng-template>

<ng-template #countryColumn let-village="village">
    {{(village ? village.province.region.country.name : '')}}
</ng-template>

<ng-template #createdAtColumn let-createdAt="createdAt">
    {{createdAt | date:'dd-MM-yyyy HH:mm'}}
</ng-template>

<ng-template #statusColumn let-status="status">
    <ng-container *ngIf="status === 1; else otherStatus">
        <h5 style="margin: 0px;"><span class="badge badge-success" style="font-weight: normal;"><i
                    class="fa fa-check"></i>{{status | companyStatus}}</span></h5>
    </ng-container>
    <ng-template #otherStatus>
        <ng-container *ngIf="status === 2; else delete1Template">
            <h5 style="margin: 0px;"><span class="badge badge-warning" style="font-weight: normal;"><i
                        class="fa fa-exclamation"></i>{{status | companyStatus}}</span></h5>
        </ng-container>
        <ng-template #delete1Template>
            <h5 style="margin: 0px;"><span class="badge badge-danger" style="font-weight: normal;"><i
                        class="fa fa-minus-circle"></i>{{status | companyStatus}}</span></h5>
        </ng-template>
    </ng-template>
</ng-template>

<ng-template #idColumn let-id="id">
    {{id}}
</ng-template>

<ng-template #actionsColumn let-id="id">
    <div class="btn-group navbar p-0" style="display: block">
        <a href="companies/edit/{{id}}" class="btn btn-secondary btn-sm"><i class="fa fa-pencil-alt"></i> Edit</a>
        <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 30px">
            <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
            <a href="companies/details/{{id}}" class="dropdown-item btn-sm"><i class="fa fa-search-plus"></i>
                View</a>
            <button type="button" class="dropdown-item btn-sm" (click)="softDeleteCompany(id)"><i
                    class="fa fa-trash-alt"></i>Delete</button>
        </div>
    </div>
</ng-template>
